"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { ArrowTopRightOnSquareIcon, ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
import WavesIcon from "@/components/common/icons/WavesIcon";
interface WaveCreatorPreviewItemProps {
  readonly wave: ApiWave;
}
export const WaveCreatorPreviewItem: React.FC<WaveCreatorPreviewItemProps> = t0 => {
  const $ = _c(23);
  const {
    wave
  } = t0;
  const isDirectMessage = wave.chat.scope.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== isDirectMessage || $[1] !== wave.id) {
    t1 = getWaveRoute({
      waveId: wave.id,
      isDirectMessage,
      isApp: false
    });
    $[0] = isDirectMessage;
    $[1] = wave.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const waveHref = t1;
  let t2;
  if ($[3] !== wave.picture) {
    t2 = wave.picture ? getScaledImageUri(wave.picture, ImageScale.W_AUTO_H_50) : null;
    $[3] = wave.picture;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const imageSrc = t2;
  const FallbackIcon = isDirectMessage ? ChatBubbleLeftRightIcon : WavesIcon;
  let t3;
  if ($[5] !== FallbackIcon || $[6] !== imageSrc || $[7] !== wave.name) {
    t3 = <div className="tw-flex tw-h-10 tw-w-10 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-white/10">{imageSrc ? <Image src={imageSrc} alt={wave.name ? `Wave ${wave.name}` : "Wave picture"} width={40} height={40} className="tw-h-full tw-w-full tw-object-cover" /> : <FallbackIcon className="tw-h-4 tw-w-4 tw-text-iron-300" />}</div>;
    $[5] = FallbackIcon;
    $[6] = imageSrc;
    $[7] = wave.name;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== wave.name) {
    t4 = <div className="tw-truncate tw-text-sm tw-font-semibold tw-text-iron-100">{wave.name}</div>;
    $[9] = wave.name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== wave.metrics.latest_drop_timestamp) {
    t5 = wave.metrics.latest_drop_timestamp ? <><span>Last drop: </span><span className="tw-text-iron-300">{getTimeAgoShort(wave.metrics.latest_drop_timestamp)}</span></> : "No drops yet";
    $[11] = wave.metrics.latest_drop_timestamp;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div className="tw-truncate tw-text-xs tw-text-iron-500">{t5}</div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="tw-min-w-0 tw-flex-1">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArrowTopRightOnSquareIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-500 desktop-hover:group-hover:tw-text-iron-300" />;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t7 || $[21] !== waveHref) {
    t9 = <Link href={waveHref} prefetch={false} className="tw-group tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-iron-800/70 tw-bg-iron-950/60 tw-px-4 tw-py-3 tw-no-underline tw-transition tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-400/60 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-bg-iron-900/60">{t3}{t7}{t8}</Link>;
    $[19] = t3;
    $[20] = t7;
    $[21] = waveHref;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};